import { ModelType } from '../../config/models';
import { SET_CURRENT_TAB, CurrentTabActionTypes } from '../actionTypes';

const setCurrentTab = (tab: ModelType): CurrentTabActionTypes => ({
  type: SET_CURRENT_TAB,
  payload: tab,
});

export default setCurrentTab;
